import React, { useEffect, useState } from "react";
import { Controller, useWatch } from "react-hook-form";
import { CiCirclePlus, CiCircleRemove } from "react-icons/ci";
import Select from "react-select";
import { Col } from "reactstrap";
import useLocationApi from "../../../../hooks/useLocationApi";
import { selectInputStyle } from "../../../../utils/SelectInputStyles";
import InputField from "../../inputs/InputField";
import MobileNoInputField from "../../inputs/MobileNoInputField";
import { AddressDetailsFormContainer } from "./AddressDetailsFormContainer";
import { ErrorMessage } from "../../../../utils/ErrorMessage";
import { useSelector } from "react-redux";
import MandatoryField from "../../../../utils/MandatoryField";
import { axiosFunction } from "../../../commonFunctions/axiosFunction"; 
import { v2ReactURL } from "../../../../utils/constant";
import { toastMessage } from "../../../commonFunctions";
import {AddressDetailsFormNews, city, countriesCode, fields, gstType, GstValidMsg, state } from "./FormComponentSchema";
import {z} from "zod";
import { CityListArrayOfObject, CountryListAaray, CountryLists, StateListArrayOfObject } from "../../../../pages/Contact/EditContact/EditContactSchema";


export const CountryListObject =   z.object({
    countriesId: z.number(),
    countriesCode: z.string(),
    countriesName: z.string(),
    currencyCode: z.string().nullable(),
    currencyName: z.string().nullable(),
    currencySymbol: z.string().nullable(),
    isbrnrequired: z.number(),
    countryDialCodePrefix: z.number(),
    countryImageName: z.string(),
  })
 
export const StateList =  z.object({
    countriesCode: z.string().nullable(),   
    stateCode: z.string().nullable(),         
    stateName: z.string(),              
    wooCommerceStateCode: z.string().nullable(), 
    zoneCode: z.string().nullable(),  
  })
 
export const CityList =  z.object({
    cityCode: z.string().nullable(),              
    cityId: z.number().int(),                 
    cityName: z.string().nullable(),               
    countriesCode: z.string().nullable(),    
    stateCode: z.string().nullable(),       
    zoneCode: z.string().nullable(),
  })
 
  
  export type CountryAarayList = z.infer<typeof CountryListObject>;
  export type StateListArray = z.infer<typeof StateList>;
  export type CityListArray = z.infer<typeof CityList>;
  export const gstTypeList:gstType [] = [
    { value: "UnRegistered", label: "UnRegistered" },
    { value: "Registered", label: "Registered Regular" },
    { value: "Composition Scheme", label: "Registered Composition" },
    // { value: "Composition Scheme", label: "Composition Scheme" },
    { value: "Input Service Distributor", label: "Input Service Distributor" },
    { value: "E-Commerce Operator", label: "E-Commerce Operator" },
    { value: "UIN Holders", label: "UIN Holders" },
  ];
  interface selectedOption {
    value : string,
    label : string
  }
const AddressDetailsFormNew: React.FC<AddressDetailsFormNews>  = ({
  setSelectedGSTType,
  control,
  register,
  newContactCreatedDetail,
  customerTaxType,
  fields,
  append,
  remove,
  errors,
  setDeletedAddress,
  setValue,
  getValues,
  showVerifyBtn,
  setShowVerifyBtn,
  setGstValidMsg,
  gstValidMsg,
}) => {
  const { getCountryList, getCityList, getStateList } = useLocationApi();
  const sessionList = useSelector((state : any) => state.sessionData.sessionScope);
  // const taxtype = sessionList?.governmentTaxType || "gst";
  // const taxtype = !newContactCreatedDetail?.ContactDetails?.vatNo?.trim() ? "gst" : "vat";
  
  const contactType = useSelector((state : any) => state.contactType);
  const phoneNo = useSelector((state : any) => state.phoneNo);
  const [countryList, setCountryList] = useState<countriesCode[]>([]);  
  const [countryCodeImg, setCountryCodeImg] = useState<CountryLists[]>([]);  
  const [stateList, setStateList] = useState<state[]>([]);        
  const [cityList, setCityList] = useState<city[]>([]); 
  
  // const taxtype = contactType === 'Suppliers' 
  // ? (sessionList?.governmentTaxType || "gst") 
  // : (!newContactCreatedDetail?.ContactDetails?.vatNo?.trim() ? "gst" : "vat");

  const taxtype = contactType === 'customers' 
  ? customerTaxType
  :  (sessionList?.governmentTaxType || "gst") ;




  const mapGSTType = (value: string): string => {
    // if (value === "Registered") {
    //   return "Registered Regular";
    // }
    return value && value.toLowerCase();
  };

  interface Visibility {
    [key: number]: any;  
  }
  // console.log("newContactCreatedDetail",)
  const fetchInitialData = async (
    labelName : string,
    defaultCountryCode : string ,
    defaultStateCode : string ,
    defaultCityCode : string,
    index : number
  ) => {
    try {
     
      const countries = await getCountryList();
      // console.log("countries?.response.length",countries?.response.length)
      if (countries?.response.length > 0) {
        const parsedResult = CountryListAaray.safeParse(countries?.response);

        if (parsedResult.success && countries?.response?.length > 0) {
          
            const countryOptions = countries.response.map((country: CountryAarayList) => ({
              value: country.countriesCode,
              label: country.countriesName,
            }));
            setCountryList(countryOptions);
        
            const defaultCountry = countryOptions.find(
              (c: CountryAarayList) => c[labelName as keyof CountryAarayList] === defaultCountryCode
            );
            if (defaultCountry) {
              setValue?.(`addressDetails[${index}].countriesCode`, defaultCountry);
              const states = await getStateList(defaultCountryCode === defaultCountry.value ? defaultCountryCode : defaultCountry.value);
               
              const parsedStateResult = StateListArrayOfObject.safeParse(states?.response);
               if(parsedStateResult.success && states?.response?.length > 0){
               
                  const stateOptions = states.response.map((state: StateListArray) => ({
                    value: state.stateCode,
                    label: state.stateName,
                  }));
                  setStateList(stateOptions);
          
                  const defaultState = stateOptions.find(
                    (s: StateListArray) => s[labelName as keyof StateListArray] === defaultStateCode
                  );
          
                  if (defaultState) {
                    setValue?.(`addressDetails[${index}].state`, defaultState);
          
                    const cities = await getCityList(defaultStateCode === defaultState.value ? defaultStateCode : defaultState.value);
                    const parsedStateResult = CityListArrayOfObject.safeParse(cities?.response);
                    if(parsedStateResult.success && cities?.response?.length > 0){  {
                    
                        const cityOptions = cities.response.map((city: CityListArray) => ({
                          value: city.cityCode,
                          label: city.cityName,
                        }));
                        setCityList(cityOptions);
            
                        const defaultCity = cityOptions.find(
                          (c: CityListArray) => c[labelName as keyof CityListArray] === defaultCityCode
                        );
                        if (defaultCity) {
                          setValue?.(`addressDetails[${index}].city`, defaultCity);
                        } else {
                          setValue?.(`addressDetails[${index}].city`, null);
                        }
                      }  
                    }
                  }
           
               }
      
            }
          
        } else {
          console.error("Parsing error:", parsedResult.error);
        }
      } else {
        console.error("Response data is null or undefined.");
      }
  
    } catch (error) {
      console.error("Error fetching location data:", error);
    }
    
  };

  useEffect(() => {
    if (newContactCreatedDetail?.ContactDetails?.contactAddress) {
      newContactCreatedDetail?.ContactDetails?.contactAddress?.forEach(
        (field,index) => {
          if (
            field.countryDialCodePrefix !=
              phoneNo?.prefixes[`addressDetailsmobNo[${index}]`] &&
            phoneNo?.prefixes[`addressDetailsmobNo[${index}]`] != "91"
          ) {
            // fetchInitialData("IN", "", "", index);
          } else {
            fetchInitialData(
              "value",
              field.countriesCode,
              field.stateCode,
              field.cityCode,
              index
            );
          }
        }
      );
    }
  }, []);

      //  console.log("countryList",countryList)
  useEffect(() => {
    const fetchCountryList = async () => {
      try {
        const countryList = await getCountryList();
  
        if (countryList) {
          const parsedResult = CountryListAaray.safeParse(countryList?.response);
            if (parsedResult.success) {
    
            const countryListWithValueLabel = parsedResult.data.map((eachCountry: CountryAarayList) => ({
              value: eachCountry.countriesCode,
              label: eachCountry.countriesName,
            }));
            setCountryCodeImg(parsedResult.data)
            setCountryList(countryListWithValueLabel);
          } else {
            console.error("Parsing error:", parsedResult.error.format());
          }
        } else {
          console.error("Response data is null or undefined.");
        }
      } catch (error) {
        console.error("Error fetching country list:", error);
      }
    };
  
    fetchCountryList();
  }, []);
  
  

  
  const getSelectedCountryWiseState = async (selectedCountryCode: string) => {
    try {
      const getCountryWiseState = await getStateList(selectedCountryCode);
   
      const parsedResult = StateListArrayOfObject.safeParse(getCountryWiseState?.response);
  
      if (parsedResult.success) {
          const getStateWithValueLabel = parsedResult.data.map((eachState: StateListArray) => ({
          value: eachState.stateCode ?? "",   
          label: eachState.stateName,
        }));
  
        setStateList(getStateWithValueLabel);
      } else {
        console.error("Parsing error:", parsedResult.error.format());
        setStateList([]);   
      }
    } catch (error) {
      console.error("Error fetching state list:", error);
      setStateList([]);  // In case of fetch error, clear the state list
    }
  };
  


  const getSelectedStateWiseCity = async (selectedStateCode : string) => {

    const getStateWiseCity = await getCityList(selectedStateCode);
    const parsedStateResult = CityListArrayOfObject.safeParse(getStateWiseCity?.response);
    if(parsedStateResult.success){
      if (!!getStateWiseCity?.response?.length) {
        const getCityWithValueLabel = getStateWiseCity?.response?.map(
          (eachCity : CityListArray) => {
            return {
              value: eachCity.cityCode,
              label: eachCity.cityName,
            };
          }
        );
  
        setCityList(getCityWithValueLabel);
      } else {
        setCityList([]);
      }
    };
 
   
  }

  const handleAddNewBtn = () => {
    append({
      // contactAddressId: 0,
      gstType: { value: "UnRegistered", label: "UnRegistered" },
      contactFirstName: null,
      contactLastName: null,
      contactCompanyName: null,
      mobNo: null,
      contactEmail: null,
      addressLine1: null,
      addressLine2: null,
      pincode: null,
      GSTIN: "",

      countriesCode: {
        value: sessionList?.countryCode || "IN",
        label: sessionList?.countryName || "India",
      },
      state: {
        value: sessionList?.stateCode || "24",
        label: sessionList?.stateName || "Gujarat",
      },
      city: {
        value: sessionList?.cityCode || "938",
        label: sessionList?.cityName || "Ahmedabad",
      },
    });
  };

  const handleGSTTypeChange = (selectedOption: selectedOption | null, index: number) => {
    const updatedField = fields[index];
    if (updatedField) {
      updatedField.gstType = selectedOption
        ? {
            value: selectedOption.value,
            label: selectedOption.label,
          }
        : null;  
    }
    setSelectedGSTType(selectedOption);
  };

  const handleRemoveForm = (index : number, field : fields) => {
    if (field.contactAddressId) {
      setDeletedAddress &&   setDeletedAddress((prevDeletedAddress: string[]) => [
        ...prevDeletedAddress,
        field.contactAddressId,
      ]);
      remove(index);
    } else {
      remove(index);
    }

    setShowVerifyBtn((prevVerifyButtonVisible: Visibility) => {
      const updatedVisibility = { ...prevVerifyButtonVisible }; 
      delete updatedVisibility[index];
      const shiftedVisibility: Visibility = {};  
           Object.keys(updatedVisibility).forEach((key) => {
        const numericKey = parseInt(key, 10);  
        if (numericKey > index) {
          shiftedVisibility[numericKey - 1] = updatedVisibility[+key];  
        } else {
          shiftedVisibility[numericKey] = updatedVisibility[+key];  
        }
      });
    
      return shiftedVisibility;
    });
  };

  const watchGSTType = useWatch({
    control,
    name: fields.map((_, index) => `addressDetails[${index}].gstType`),
  });
   
  const watchGSTIN = useWatch({
    control,
    name: fields.map((_, index) => `addressDetails[${index}].GSTIN`),
  });
   
  useEffect(() => {
    fields.forEach((_field, index) => {
      if (
        getValues(`addressDetails[${index}]`)?.gstType?.value === "UnRegistered"
      ) {
        setValue?.(`addressDetails[${index}].GSTIN`, "");
      }
    });
  }, [watchGSTType, control, fields]);

  const handleVerifyGstno = async (index : number) => {
    const GSTIN = watchGSTIN[index];
    const response = await axiosFunction(
      `${v2ReactURL}/contact/${contactType}/getgstdeatail?gstNo=${GSTIN}`,
      "POST",
      {}
    );

    if (response?.data && response?.data?.status) {
      setGstValidMsg((prev: GstValidMsg) => ({
        ...prev, 
        [index]: {
          msg: "Verified",  
          disabled: true,   
        }
      }));
      
      //  console.log("response?.data?.response",response?.data?.response)
      const res = response?.data?.response
      // const data = response?.data?.response?.taxpayerInfo;
      const address = response?.data?.response?.pradr?.addr;
      const fullAddressLine1 = `${address?.bno},${address?.bnm},${address?.st},${address?.loc}`;
      const stateName = address?.stcd;
      const cityName = address?.dst;
      const isSupplier = newContactCreatedDetail?.typeOfContact === "suppliers" || newContactCreatedDetail?.type === "suppliers";
      const contactName = res?.tradeNam;
      const pincode = res?.pradr?.addr?.pncd;
      const addressLine1 = fullAddressLine1;
      const gstNumber = GSTIN;
      const setGstNumber = gstNumber.slice(2, -3)
      
    
      if (index === 0 && !isSupplier) {
        if(newContactCreatedDetail?.typeOfContact === "transport" || newContactCreatedDetail?.gstverifyoption === 0){
          setValue?.("firstName",contactName,{
            shouldValidate: true,
            shouldDirty: true,    
            shouldTouch: true,    
          })
        } else {
          setValue?.("companyName", res?.tradeNam,{
            shouldValidate: true,
            shouldDirty: true,    
            shouldTouch: true,    
          })
        };
        setValue?.("pincode",pincode,{
          shouldValidate: true,
          shouldDirty: true,    
          shouldTouch: true,    
        });
        setValue?.("transporterId", watchGSTIN.join(", "),{
          shouldValidate: true,
          shouldDirty: true,    
          shouldTouch: true,    
        });
        if (index === 0) {
          setValue?.("panNo",setGstNumber,{
            shouldValidate: true,
            shouldDirty: true,    
            shouldTouch: true,    
          });
        }
      }
      else{
        if (index === 0 ) {
          setValue?.("companyName", res?.tradeNam,{
            shouldValidate: true,
            shouldDirty: true,    
            shouldTouch: true,    
          })
          setValue?.("panNo",setGstNumber,{
            shouldValidate: true,
            shouldDirty: true,    
            shouldTouch: true,    
          });
        }
        setValue?.("pincode", pincode,{
          shouldValidate: true,
          shouldDirty: true,    
          shouldTouch: true,    
        });
        // setValue?.("panNo",setGstNumber)
        }
      
      setValue?.(`addressDetails[${index}].${isSupplier ? "contactCompanyName" : (newContactCreatedDetail?.typeOfContact === "transport" || newContactCreatedDetail?.gstverifyoption === 0)  ? "contactFirstName":"contactCompanyName"}`, contactName,{
        shouldValidate: true,
        shouldDirty: true,    
        shouldTouch: true,    
      });
      setValue?.(`addressDetails[${index}].pincode`, pincode,{
        shouldValidate: true,
        shouldDirty: true,    
        shouldTouch: true,    
      });
      
      setValue?.(`addressDetails[${index}].addressLine1`, addressLine1,{
        shouldValidate: true,
        shouldDirty: true,    
        shouldTouch: true,    
      });
      
      fetchInitialData("label", "India", stateName, cityName, index);
    } else {
      setGstValidMsg((prev) => {
        return {
          ...prev,
          [index]: {
            msg: "Invalid GSTIN",
            disabled: true,
          },
        };
      });
      toastMessage("Your GST Number is invalid. Enter again....", "error");
    }
  };

  

const handleVerifiedBtn = (index: number, e: React.ChangeEvent<HTMLInputElement>) => {
  const gstValue = e.target.value;
  const gstRegex =
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;

  const gstValid = gstRegex.test(gstValue); 
  if (gstValid) {
    setShowVerifyBtn((prev) => ({
      ...prev,
      [index]: true,
    }));
    setGstValidMsg((prev) => {
      return {
        ...prev,
        [index]: {
          msg: "Verify",
          disabled: false,
        },
      };
    });
  } 
    else {
      setShowVerifyBtn((prev) => ({
        ...prev,
        [index]: false,
      }));
      setGstValidMsg((prev) => {
        return {
          ...prev,
          [index]: {
            msg: "",
            disabled: false,
          },
        };
      });
    }
};
 
// useEffect(() => {
//     if (fields && fields.length > 0) {
//       fields.forEach((field, index) => {
//         setValue?.(`addressDetails[${index}].contactEmail`, field?.email );
//         setValue?.(`addressDetails[${index}].mobNo`, field?.phoneNo);
//       }); 
  
//   }
// }, []); 
  return (
    <AddressDetailsFormContainer>
      <div>
        {fields?.map((field, index) => (
          <div key={field.id} className="address-details-form">
            <div className="form-container">
              {taxtype === "gst" && (
                <>
                  <Col md={"auto"}>
                    <label>GST Type</label>
                    <Controller
                      name={`addressDetails[${index}].gstType`}
                      control={control}
                      defaultValue={gstTypeList.find(
                        (option) =>
                          option.value.toLowerCase() ===
                          mapGSTType(field.gstType?.value || "")
                      )}
                      render={({ field: { onChange, value } }) => (
                        <Select
                          isSearchable={false}
                          styles={{
                            ...selectInputStyle,
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9997, // HIGH z-index to bring it above everything
                            }),
                            control: (base, state) => {
                              const originalControl = selectInputStyle.control?.(base, state) || base;
                              return {
                                ...originalControl,
                                marginTop : '0px',
                              };
                            },
                            menu: (base) => ({
                              ...base,
                              zIndex: 9997, // Also add z-index to the menu itself
                            }),
                          }}
                          value={gstTypeList.find(
                            (option) =>
                              option.value.toLowerCase() === mapGSTType(value?.value)
                          )}
                          options={gstTypeList}
                          menuPortalTarget={document.body}
                          onChange={(selectedOption) => {
                            onChange(selectedOption);
                            handleGSTTypeChange(selectedOption, index);
                          }}
                        />
                      )}
                    />
                  </Col>

                  <Col md={"auto"}>
                    <div className="gst-verify">
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <InputField
                          defaultValue={`addressDetails[${index}].GSTIN`}
                          labelName="GSTIN"
                          placeholder="GSTIN"
                          name={`addressDetails[${index}].GSTIN`}
                          register={register}
                          required={
                            field?.gstType?.value !== "UnRegistered"
                              ? true
                              : false
                          }
                          disabled={
                            field?.gstType?.value === "UnRegistered"
                              ? true
                              : false
                          }
                          onChange={(e) => {
                            handleVerifiedBtn(index, e); // Pass index and event
                          }}
                          errorMessage={
                            errors &&
                            field.gstType &&
                            field.gstType.value !== "UnRegistered" &&
                            ErrorMessage(
                              errors?.addressDetails &&
                                errors?.addressDetails[index]?.GSTIN?.message
                            )
                          }
                        />
                      </div>

                      {showVerifyBtn[index] &&
                        gstValidMsg[index]?.msg &&
                        getValues(`addressDetails[${index}]`)?.GSTIN && (
                          <button
                            className="gst-verify-btn"
                            onClick={() => handleVerifyGstno(index)}
                            disabled={!!gstValidMsg[index]?.disabled}
                          >
                            {gstValidMsg[index]?.msg}
                          </button>
                        )}
                    </div>
                  </Col>
                </>
              )}

              <Col md={"auto"}>
                <InputField
                   
                  labelName="Contact First Name"
                  placeholder="Contact First Name"
                  name={`addressDetails[${index}].contactFirstName`}
                  register={register}
                  required={contactType !== "suppliers"}
                  errorMessage={
                    errors &&
                    ErrorMessage(
                      errors?.addressDetails &&
                        errors?.addressDetails[index]?.contactFirstName?.message
                    )
                  }
                />
              </Col>

              <Col md={"auto"}>
                <InputField
                   
                  labelName="Contact Last Name"
                  placeholder="Contact Last Name"
                  name={`addressDetails[${index}].contactLastName`}
                  register={register}
                  errorMessage={
                    errors &&
                    ErrorMessage(
                      errors?.addressDetails &&
                        errors?.addressDetails[index]?.contactLastName?.message
                    )
                  }
                />
              </Col>

              <Col>
                <InputField
                   
                  labelName="Contact Company Name"
                  placeholder="Contact Company Name"
                  name={`addressDetails[${index}].contactCompanyName`}
                  register={register}
                  required={contactType === "suppliers"}
                  errorMessage={
                    errors &&
                    ErrorMessage(
                      errors?.addressDetails &&
                        errors?.addressDetails[index]?.contactCompanyName
                          ?.message
                    )
                  }
                />
              </Col>
            </div>

            <div className="form-container">
              <Col md={"auto"}>
                <InputField
                  labelName="Contact Email"
                  placeholder="Contact Email"
                  name={`addressDetails[${index}].contactEmail`}
                  defaultValue={field?.email ?? ""}
                  register={register}
                  errorMessage={
                    errors &&
                    ErrorMessage(
                      errors?.addressDetails &&
                        errors?.addressDetails[index]?.contactEmail?.message
                    )
                  }
                />
              </Col>
              <Col md={"auto"}>
                <MobileNoInputField
                  countryCodeImg={countryCodeImg}
                  labelName="Contact No."
                  control={control}
                  name={`addressDetails[${index}].mobNo`}
                  inputName={`addressDetailsmobNo[${index}]`}
                  newContactCreatedDetail={newContactCreatedDetail}
                  placeHolder={"Contact Number"}
                  errors={errors}
                  index={index}
                  setValue={setValue}
                  fetchInitialData={fetchInitialData}
                />
                {errors &&
                  ErrorMessage(
                    errors?.addressDetails &&
                      errors?.addressDetails[index]?.mobNo?.message
                  )}
              </Col>

              <Col>
                <InputField
                  labelName="Address Line 1"
                  placeholder="Address Line 1"
                  name={`addressDetails[${index}].addressLine1`}
                  register={register}
                  errorMessage={
                    errors &&
                    ErrorMessage(
                      errors?.addressDetails &&
                        errors?.addressDetails[index]?.addressLine1?.message
                    )
                  }
                />
              </Col>
              <Col>
                <InputField
                  
                  labelName="Address Line 2"
                  placeholder="Address Line 2"
                  name={`addressDetails[${index}].addressLine2`}
                  register={register}
                  errorMessage={
                    errors &&
                    ErrorMessage(
                      errors?.addressDetails &&
                        errors?.addressDetails[index]?.addressLine2?.message
                    )
                  }
                />
              </Col>
            </div>

            <div className="form-container">
              <Col md={"auto"}>
                <InputField
                  
                  labelName="Pincode"
                  placeholder="Pincode"
                  name={`addressDetails[${index}].pincode`}
                  register={register}
                  errorMessage={
                    errors &&
                    ErrorMessage(
                      errors?.addressDetails &&
                        errors?.addressDetails[index]?.pincode?.message
                    )
                  }
                />
              </Col>
              <Col md="auto">
                <label className="select-label">
                  Country
                  <MandatoryField />
                </label>
                <Controller
                  name={`addressDetails[${index}].countriesCode`}
                  control={control}
                  render={({ field }) => (
                    <Select
                      placeholder="Select Country"
                      styles={{
                        ...selectInputStyle,
                        control: (base, state) => {
                          const originalControl = selectInputStyle.control?.(base, state) || base;
                          return {
                            ...originalControl,
                            marginTop : '0px',
                          };
                        },
                      }}
                      {...field}
                      onChange={(selectedCountry) => {
                        getSelectedCountryWiseState(selectedCountry?.value ?? 'IN');
                        field.onChange(selectedCountry);
                        setValue?.(`addressDetails[${index}].state`, null);
                        setValue?.(`addressDetails[${index}].city`, null);
                      }}
                      options={countryList}
                      menuPortalTarget={document.body}
                    />
                  )}
                />
                {errors &&
                  ErrorMessage(
                    errors?.addressDetails &&
                      errors?.addressDetails[index]?.countriesCode?.message
                  )}
              </Col>

              <Col md="auto">
                <label className="select-label">
                  State
                  <MandatoryField />
                </label>
                <Controller
                  name={`addressDetails[${index}].state`}
                  control={control}
                  render={({ field }) => (
                    <Select
                      placeholder="Select State"
                      styles={{
                        ...selectInputStyle,
                        control: (base, state) => {
                          const originalControl = selectInputStyle.control?.(base, state) || base;
                          return {
                            ...originalControl,
                            marginTop : '0px',
                          };
                        },
                      }}
                      {...field}
                      onChange={(selectedState) => {
                        getSelectedStateWiseCity(selectedState?.value ?? '');
                        field.onChange(selectedState);
                        setValue?.(`addressDetails[${index}].city`, null);
                      }}
                      options={stateList}
                      menuPortalTarget={document.body}
                      onMenuOpen={() => {
                        fields.map((field) => {
                          if (field?.countriesCode?.value) {
                            getSelectedCountryWiseState(
                              getValues(
                                `addressDetails[${index}].countriesCode.value`
                              )
                            );
                          }
                        });
                      }}
                    />
                  )}
                />
                {errors &&
                  ErrorMessage(
                    errors?.addressDetails &&
                      errors?.addressDetails[index]?.state?.message
                  )}
              </Col>

              <Col md="auto">
                <label className="select-label">
                  City <MandatoryField />
                </label>
                <Controller
                  name={`addressDetails[${index}].city`}
                  control={control}
                  render={({ field }) => (
                    <Select
                      placeholder="Select City"
                      styles={{
                        ...selectInputStyle,
                        control: (base, state) => {
                          const originalControl = selectInputStyle.control?.(base, state) || base;
                          return {
                            ...originalControl,
                            marginTop : '0px',
                          };
                        },
                      }}
                      {...field}
                      options={cityList}
                      menuPortalTarget={document.body}
                      onMenuOpen={() => {
                        fields.map((field) => {
                          // console.log("field", ,)
                          if (field?.state?.value) {
                            getSelectedStateWiseCity(
                              getValues(`addressDetails[${index}].state.value`)
                            );
                          }
                        });
                      }}
                    />
                  )}
                />
                {errors &&
                  ErrorMessage(
                    errors?.addressDetails &&
                      errors?.addressDetails[index]?.city?.message
                  )}
              </Col>
            </div>

            {fields.length > 1 && (
              <div className="remove-btn">
                <button
                  onClick={() => {
                    handleRemoveForm(index, field);
                  }}
                >
                  <CiCircleRemove size={20} />
                  Remove
                </button>
              </div>
            )}
          </div>
        ))}
      </div>

      <button onClick={handleAddNewBtn} className="add-new-btn">
        <CiCirclePlus size={20} />
        Add New
      </button>
    </AddressDetailsFormContainer>
  );
};

export default AddressDetailsFormNew;